import React, { useEffect, useRef, useState } from "react";
import "./HealthOneCounter.scss";
import CountUp from "react-countup";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";

const HealthOneCounter = () => {
  const sectionRef = useRef(null);
  const [animate, setAnimate] = useState(false);
  const { document: dbCountersDocuments } = useDocument("counters", "homeCounter");

  const counters = dbCountersDocuments
    ? [
        dbCountersDocuments.firstCounter,
        dbCountersDocuments.secondCounter,
        dbCountersDocuments.thirdCounter,
        dbCountersDocuments.fourthCounter,
      ]
    : [];

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isVisible) {
        setAnimate(false);
        setTimeout(() => {
          setAnimate(true);
        }, 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="stats-section" ref={sectionRef}>
      {counters.map((item, index) => (
        <div className="stat-box" key={index}>
          <div
            className="icon"
            dangerouslySetInnerHTML={{ __html: item.iconName }}
          />
          <div className="text">
            <div className="number">
              {item.number !== undefined ? (
                animate ? (
                  <>
                    <CountUp
                      end={item.number}
                      duration={5}
                      separator=","
                      key={`${item.number}-${animate}`}
                    />
                    {/* Agar item.sign exist karta hai to usko number ke baad dikhayenge */}
                    {item.sign && <span className="sign">{item.sign}</span>}
                  </>
                ) : (
                  <>0{item.sign && <span className="sign">{item.sign}</span>}</>
                )
              ) : (
                ""
              )}
            </div>
            <div className="label">{item.name}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HealthOneCounter;
